import { useEffect, useRef } from 'react'
import styles from './HorizontalScroll.module.css'

interface HorizontalScrollProps {
  children: React.ReactNode
  variant?: 'wide' | 'member'
  scrollToSelector?: string
  scrollKey?: string
}

export default function HorizontalScroll({
  children,
  variant = 'wide',
  scrollToSelector,
  scrollKey,
}: HorizontalScrollProps) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!scrollToSelector || !ref.current) return

    const frame = requestAnimationFrame(() => {
      const container = ref.current
      if (!container) return
      const target = container.querySelector(scrollToSelector)
      if (!target) return
      const cr = container.getBoundingClientRect()
      const tr = target.getBoundingClientRect()
      container.scrollLeft += tr.left - cr.left
    })

    return () => cancelAnimationFrame(frame)
  }, [scrollToSelector, scrollKey])

  return (
    <div className={styles.bleed}>
      <div
        className={[styles.scroll, variant === 'wide' ? styles.wide : styles.member].join(' ')}
        ref={ref}
      >
        {children}
      </div>
    </div>
  )
}
